import { render, staticRenderFns } from "./CourseTextAssignmentView.vue?vue&type=template&id=6e27eb60&scoped=true"
import script from "./CourseTextAssignmentView.vue?vue&type=script&lang=js"
export * from "./CourseTextAssignmentView.vue?vue&type=script&lang=js"
import style0 from "./CourseTextAssignmentView.vue?vue&type=style&index=0&id=6e27eb60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e27eb60",
  null
  
)

export default component.exports